module.exports = __webpack_public_path__ + "static/img/3-info-b7.64259ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-info-b7.jpg
// module id = t8zM
// module chunks = 0